// extracted by mini-css-extract-plugin
module.exports = {"container":"Featured_container__snvxA","eyebrow":"Featured_eyebrow__JHsZU","link":"Featured_link__rWnB7","content":"Featured_content__11gxa","icon":"Featured_icon__2_VbE"};